module.exports = __webpack_public_path__ + "img/sort.da638a28.svg";